/** @format */

import React, { useState, useEffect, useRef } from "react";
import SecureStorage from "react-secure-storage";

import Water_level1 from "../assets/Water_level1.png";
import Water_level2 from "../assets/Water_level2.png";
import Water_level3 from "../assets/Water_level3.png";
import Water_level4 from "../assets/Water_level4.png";
import Water_level5 from "../assets/Water_level5.png";

const constants = require("file-configs/constants");

export const getDataDropdownProblemType = async () => {
  const options = [
    { id: 1, name: "อื่นๆ" },
    { id: 2, name: "ไฟฟ้า" },
    { id: 3, name: "น้ำท่วม" },
  ];

  return options;
};

export const getDataDropdownWaterLevel = async (lan) => {
  let options = [];
  if (lan != "ENG") {
    options = [
      { level: 1, name: "ระดับข้อเท้า", photo: Water_level1 },
      { level: 2, name: "ระดับเข่า", photo: Water_level2 },
      { level: 3, name: "ระดับเอว", photo: Water_level3 },
      { level: 4, name: "ระดับเหนือเอว", photo: Water_level4 },
      { level: 5, name: "ระดับคาง", photo: Water_level5 },
    ];
  } else {
    options = [
      { level: 1, name: "Ankle", photo: Water_level1 },
      { level: 2, name: "Knee", photo: Water_level2 },
      { level: 3, name: "Waist", photo: Water_level3 },
      { level: 4, name: "Above waist", photo: Water_level4 },
      { level: 5, name: "Chin", photo: Water_level5 },
    ];
  }

  return options;
};

export const getDataDropdownTimeFlood = async (lan) => {
  let options = [];
  if (lan != "ENG") {
    options = [
      { level: 1, name: "ท่วมน้อยกว่า 1 ชั่วโมง" },
      { level: 2, name: "ท่วมน้อยกว่า 3 ชั่วโมง" },
      { level: 3, name: "ท่วมน้อยกว่า 1 วัน" },
      { level: 4, name: "ท่วมน้อยกว่า 1 อาทิตย์" },
      { level: 5, name: "ท่วมมากกว่า 1 อาทิตย์" },
    ];
  } else {
    options = [
      { level: 1, name: "Flooded for 1 hour." },
      { level: 2, name: "Flooded for 3 hours." },
      { level: 3, name: "Flooded for 1 day." },
      { level: 4, name: "Flooded for 1 week." },
      { level: 5, name: "Flooded for more than 1 week." },
    ];
  }

  return options;
};

export const getOrg = async (lat, lon, lang) => {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDAyLCJ1c2VybmFtZSI6ImZvbmR1ZXJlcG9ydCIsImV4cCI6MTg1OTI1NzMxNiwiZW1haWwiOiJmb25kdWVyZXBvcnRAZ21haWwuY29tIiwib3JpZ19pYXQiOjE3NjQ2NDkzMTYsImV4Y2hhbmdlX2tleSI6Ijk0MWRmZGViZjE1YmIwYTM4ZjVjZTk3YzI3OWJlNDYxODhmODg2YTllMmIyYzQwYjBhODlmYjRiMzIwNWQ5ZWEiLCJ0b2tlbl9pZCI6MjUsImV4cGlyZV90aW1lc3RhbXAiOjE4NTkyNTczMTZ9.2xSEz8LYoFq0tlpCYRdfebhZbvHhPUgQddxqleY5qDc",
      },
      body: JSON.stringify({
        lat: lat,
        lon: lon,
        lang: lang,
        privacy: "all",
        show_in_chatbot: true,
      }),
    };

    const response = await fetch(
      constants.APITRAFFY + "/org/responsible_org/?limit=5000&lang=" + lang,
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "getOrg error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("getOrg fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const getProblemType = async (idOrg_selected, lang) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
        // Authorization:
        //   "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDAyLCJ1c2VybmFtZSI6ImZvbmR1ZXJlcG9ydCIsImV4cCI6MTg1OTI1NzMxNiwiZW1haWwiOiJmb25kdWVyZXBvcnRAZ21haWwuY29tIiwib3JpZ19pYXQiOjE3NjQ2NDkzMTYsImV4Y2hhbmdlX2tleSI6Ijk0MWRmZGViZjE1YmIwYTM4ZjVjZTk3YzI3OWJlNDYxODhmODg2YTllMmIyYzQwYjBhODlmYjRiMzIwNWQ5ZWEiLCJ0b2tlbl9pZCI6MjUsImV4cGlyZV90aW1lc3RhbXAiOjE4NTkyNTczMTZ9.2xSEz8LYoFq0tlpCYRdfebhZbvHhPUgQddxqleY5qDc",
      },
    };

    let response = await fetch(
      constants.APITRAFFY +
        "/org/fondue-problem-custom/?limit=1000&fondue_group=" +
        idOrg_selected +
        "&lang=" +
        lang +
        "&sort_by=name",
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "getProblemType error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("getProblemType fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const checkCasePassword = async (ticket, password, lang) => {
  const authorization = await SecureStorage.getItem("authorization");

  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Device-Types": constants.DEVICE_TYPE,
        "App-Version": constants.WEB_VERSION,
      },
    };

    // /fondue-cases-api/get_case/
    let response = await fetch(
      constants.APITRAFFY +
        "/fondue-cases-api/get_case/?ticket_id=" +
        ticket +
        "&p=" +
        password +
        "&lang=" +
        lang,
      requestOptions,
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error(
        "checkCasePassword error:",
        response.status,
        response.statusText,
        errorText,
      );
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    console.error("checkCasePassword fetch failed:", error);
    throw error; // เผื่อให้ caller handle ต่อ
  }
};

export const sendData = async (
  description,
  problem_type,
  photo,
  lat,
  lng,
  org_id,
  lang,
) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
    },
    body: JSON.stringify({
      token_secret_key: "48JFIDLU",
      description: description,
      topic_name: problem_type["name"],
      photo_base64: [photo],
      latitude: lat,
      longitude: lng,
      org_id: org_id.id,
      lang: lang,
    }),
  };

  let response = await fetch(
    "https://publicapi.traffy.in.th/exchange-api/new-issue/v1",
    requestOptions,
  );

  let data = await response.json();
  // console.log('data',data);

  return data;
};

export const sendDataEN = async (
  description,
  photo,
  lat,
  lng,
  lang,
  idOrg,
  phone,
) => {
  const getPhotoSize = (base64String) => {
    const cleanedBase64 = base64String.split(",")[1] || base64String;
    const sizeInBytes = cleanedBase64.length * (3 / 4);
    const sizeInKB = sizeInBytes / 1024;
    return sizeInKB.toFixed(2);
  };

  const photoSize = getPhotoSize(photo);

  const body = {
    token_secret_key: "48JFIDLU",
    description: description,
    latitude: lat,
    longitude: lng,
    lang: lang,
    photo_base64: [photo],
    org_id: idOrg,
  };

  const phoneStr = String(phone);

  if (phoneStr.trim() !== "" && phoneStr.length >= 10) {
    body.reporter_sms = phoneStr;
  }

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDAyLCJ1c2VybmFtZSI6ImZvbmR1ZXJlcG9ydCIsImV4cCI6MTg1OTI1NzMxNiwiZW1haWwiOiJmb25kdWVyZXBvcnRAZ21haWwuY29tIiwib3JpZ19pYXQiOjE3NjQ2NDkzMTYsImV4Y2hhbmdlX2tleSI6Ijk0MWRmZGViZjE1YmIwYTM4ZjVjZTk3YzI3OWJlNDYxODhmODg2YTllMmIyYzQwYjBhODlmYjRiMzIwNWQ5ZWEiLCJ0b2tlbl9pZCI6MjUsImV4cGlyZV90aW1lc3RhbXAiOjE4NTkyNTczMTZ9.2xSEz8LYoFq0tlpCYRdfebhZbvHhPUgQddxqleY5qDc",
    },
    body: JSON.stringify({
      description: description,
      latitude: lat,
      longitude: lng,
      lang: lang,
      photo_base64: [photo],
      org_id: idOrg,
    }),
  };

  // console.log("request options:", requestOptions);

  try {
    const url = "https://publicapi.traffy.in.th/exchange-api/new-issue/v1";
    // console.log("fetch url:", url);

    const response = await fetch(url, requestOptions);

    // console.log("response object:", response);
    // console.log("response status:", response.status, response.statusText);

    // กรณีได้ 4xx / 5xx อยาก log ให้ชัดก่อน
    const rawText = await response.text();
    // console.log("response raw text:", rawText);

    let data = null;
    try {
      data = JSON.parse(rawText);
    } catch (e) {
      console.error("JSON parse error:", e);
    }

    // console.log("parsed data:", data);

    if (!response.ok) {
      console.error("response not ok, status:", response.status);
    }

    return data;
  } catch (error) {
    // กรณี network error หรือโดน block ทำให้ Failed to fetch
    console.error("fetch error:", error);
    throw error;
  }
};

export const getIpAddress = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
    },
  };

  let response = await fetch(
    "https://kong.traffy.in.th/fondue-api-php/get_ip/",
    requestOptions,
  );

  let data = await response.json();

  return data;
};

export const getPhotoAnalyzer = async (imgBase64, lang) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Device-Types": constants.DEVICE_TYPE,
      "App-Version": constants.WEB_VERSION,
      Authorization:
        "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDAyLCJ1c2VybmFtZSI6ImZvbmR1ZXJlcG9ydCIsImV4cCI6MTg1OTI1NzMxNiwiZW1haWwiOiJmb25kdWVyZXBvcnRAZ21haWwuY29tIiwib3JpZ19pYXQiOjE3NjQ2NDkzMTYsImV4Y2hhbmdlX2tleSI6Ijk0MWRmZGViZjE1YmIwYTM4ZjVjZTk3YzI3OWJlNDYxODhmODg2YTllMmIyYzQwYjBhODlmYjRiMzIwNWQ5ZWEiLCJ0b2tlbl9pZCI6MjUsImV4cGlyZV90aW1lc3RhbXAiOjE4NTkyNTczMTZ9.2xSEz8LYoFq0tlpCYRdfebhZbvHhPUgQddxqleY5qDc",
    },
    body: JSON.stringify({
      photo_base64: imgBase64,
      lang: lang,
    }),
  };

  let response = await fetch(
    "https://kong.traffy.in.th/gemini-api/photo_analyzer/v1",
    requestOptions,
  );

  let data = await response.json();

  return data;
};

export const getOTP = async (phone) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDAyLCJ1c2VybmFtZSI6ImZvbmR1ZXJlcG9ydCIsImV4cCI6MTg1OTI1NzMxNiwiZW1haWwiOiJmb25kdWVyZXBvcnRAZ21haWwuY29tIiwib3JpZ19pYXQiOjE3NjQ2NDkzMTYsImV4Y2hhbmdlX2tleSI6Ijk0MWRmZGViZjE1YmIwYTM4ZjVjZTk3YzI3OWJlNDYxODhmODg2YTllMmIyYzQwYjBhODlmYjRiMzIwNWQ5ZWEiLCJ0b2tlbl9pZCI6MjUsImV4cGlyZV90aW1lc3RhbXAiOjE4NTkyNTczMTZ9.2xSEz8LYoFq0tlpCYRdfebhZbvHhPUgQddxqleY5qDc",
      },
    };
    // https://api.traffy.in.th/otp-verification/get_otp/
    let response = await fetch(
      constants.APITRAFFY +
        "/otp-verification/get_otp/v1?platform=fonduereport&key=" +
        phone,
      requestOptions,
    );

    if (!response.ok) {
      console.error("getOTP, status:", response.status);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    // กรณี network error หรือโดน block ทำให้ Failed to fetch
    console.error("getOTP error:", error);
    throw error;
  }
};

export const verifyOTP = async (phone, otp) => {
  try {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization:
          "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoxNDIzNDAyLCJ1c2VybmFtZSI6ImZvbmR1ZXJlcG9ydCIsImV4cCI6MTg1OTI1NzMxNiwiZW1haWwiOiJmb25kdWVyZXBvcnRAZ21haWwuY29tIiwib3JpZ19pYXQiOjE3NjQ2NDkzMTYsImV4Y2hhbmdlX2tleSI6Ijk0MWRmZGViZjE1YmIwYTM4ZjVjZTk3YzI3OWJlNDYxODhmODg2YTllMmIyYzQwYjBhODlmYjRiMzIwNWQ5ZWEiLCJ0b2tlbl9pZCI6MjUsImV4cGlyZV90aW1lc3RhbXAiOjE4NTkyNTczMTZ9.2xSEz8LYoFq0tlpCYRdfebhZbvHhPUgQddxqleY5qDc",
      },
    };

    let response = await fetch(
      constants.APITRAFFY +
        "/otp-verification/verify_otp/v1?platform=fonduereport&key=" +
        phone +
        "&otp=" +
        otp,
      requestOptions,
    );

    if (!response.ok) {
      console.error("verifyOTP, status:", response.status);
    }

    let data = await response.json();

    return data;
  } catch (error) {
    // กรณี network error หรือโดน block ทำให้ Failed to fetch
    console.error("verifyOTP error:", error);
    throw error;
  }
};
